// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import dev from "../config/dev.env.js";

Vue.config.productionTip = false;

// 公用css
import "./assets/css/style.css";
import "./assets/css/index.css";
import i18n from "./i18n/i18n";

// 公用js
import "./assets/js/interface.js";
// import {ImgSrc,NaviLanguage} from './assets/js/global'

//分页插件
import "element-ui/lib/theme-chalk/index.css";
import ElementUI from "element-ui";

import PP from "./loginPop.js";

//请求封装
import { post, get, fileUpload, put, deleteFn } from "./assets/js/request1";
// 初始化i18n工具函数
import { t  } from './assets/js/i18n-helper.js';

//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$put = put;
Vue.prototype.$fileUpload = fileUpload;
Vue.prototype.$deleteFn = deleteFn;
Vue.prototype.$img = dev.BASE;
Vue.prototype.$type = localStorage.getItem("lang")==='zh_CN' ? 1 : 2;

Vue.use(ElementUI);
Vue.use(PP);

window.$t = t;


// 路由拦截
router.beforeEach(function (to, from, next) {
  let token = sessionStorage.getItem("token");
  if (token) {
    //表示登陆状态
    if (to.path == "/login") {
      next("/");
    } else {
      next();
    }
  } else {
    if (to.path != "/login" && to.meta.requiresAuth) {
      next({ path: "/login" });
    } else {
      next(); //放行了,不能少，否则不会执行跳转
    }
  }
});

// 公用组件

new Vue({
  el: "#app",
  router,
  i18n,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js